import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuProcessTypeAppResource from './LuProcessTypeAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';
import ProcessInputAppResource from './ProcessInputAppResource';
import ProcessInstanceAppResource from './ProcessInstanceAppResource';
import ProcessOutputAppResource from './ProcessOutputAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';

class ProcessAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'process';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'processes';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'processTypeId',
            'workspaceTypeUuid',
            'organizationUuid',
            'createdByOrganizationMemberUuid',
            'updatedByOrganizationMemberUuid',
            'name',
            'state',
            'isSystem',
            'projectType',
            'processType',
            'organization',
            'createdBy',
            'updatedBy',
            'processInstances',
            'processInputs',
            'processOutputs',
            'rawInputsOutputsData',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            processType: LuProcessTypeAppResource,
            projectType: WorkspaceTypeAppResource,
            organization: OrganizationAppResource,
            createdBy: OrganizationMemberAppResource,
            updatedBy: OrganizationMemberAppResource,
            processInstances: ProcessInstanceAppResource,
            processInputs: ProcessInputAppResource,
            processOutputs: ProcessOutputAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            processType: 'process_type_id',
            projectType: 'workspace_type_uuid',
            organization: 'organization_uuid',
            createdBy: 'created_by_organization_member_uuid',
            updatedBy: 'updated_by_organization_member_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            processTypeId: {
                numericality: true,
                presence: true,
            },
            workspaceTypeUuid: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
            },
            createdByOrganizationMemberUuid: {
                type: 'string',
            },
            updatedByOrganizationMemberUuid: {
                type: 'string',
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            state: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            isSystem: {
                type: 'boolean',
                presence: true,
            },
            rawInputsOutputsData: {
                type: 'object',
            },
        };
    }

}

export default ProcessAppResource;
